// Package Imports
import ModuleIdentifierConst from 'core/common/moduleIdentifier';

// Project Imports
import resourceName from 'core/common/resourceName';
import ResourceItem from 'interfaces/resource';

const ContestResource: ResourceItem = {
  name: resourceName.contest,
  identifier: ModuleIdentifierConst.CONTEST,
  meta: {
    label: 'Contest',
  },
};

export default ContestResource;
